import { render, staticRenderFns } from "./OCollapsedAutocomplete.vue?vue&type=template&id=6964ef8f&scoped=true"
import script from "./OCollapsedAutocomplete.vue?vue&type=script&lang=js"
export * from "./OCollapsedAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./OCollapsedAutocomplete.vue?vue&type=style&index=0&id=6964ef8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6964ef8f",
  null
  
)

export default component.exports